// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"src-components-Galerija----galerija-module---mainContainer---6vSB2","imagesContainer":"src-components-Galerija----galerija-module---imagesContainer---2Z-12","imageContainer":"src-components-Galerija----galerija-module---imageContainer---1ytpU","image":"src-components-Galerija----galerija-module---image---tnY6Z","back":"src-components-Galerija----galerija-module---back---3X4W1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Galerija/galerija.module.css
// module id = 563
// module chunks = 132729432747416